import { ReactNode } from 'react'

interface FieldErrorMessageProps {
  hasError: boolean
  children?: ReactNode
  message?: string
  className?: string
}

const FieldErrorMessage = ({
  hasError,
  children,
  message,
  className = '',
}: FieldErrorMessageProps) => {
  if (!children && !message) return null

  return (
    <div className={`block min-h-[1.5rem] text-xs text-red-500 ${className}`}>
      {hasError && (children || (message && <span>{message}</span>))}
    </div>
  )
}
export default FieldErrorMessage
